import { render, staticRenderFns } from "./pamongPendidikanNonFormal.vue?vue&type=template&id=13bd94f7&"
import script from "./pamongPendidikanNonFormal.vue?vue&type=script&lang=js&"
export * from "./pamongPendidikanNonFormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QBtn,QBtnGroup,QTooltip,QPagination,QDialog,QCard,QCardSection,QInput,QFile,QIcon,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QBtn,QBtnGroup,QTooltip,QPagination,QDialog,QCard,QCardSection,QInput,QFile,QIcon,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
